"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Client = require('@liqd-js/client');
class ECB {
    static rates;
    static updated = new Date();
    static async loadRates() {
        const xml = await Client.get('https://www.ecb.europa.eu/stats/eurofxref/eurofxref-hist.xml').then((res) => res.text);
        let json = {}, time = '9999-99-99';
        for (const match of xml.matchAll(/<Cube(?:\s+time="([0-9-]+)")?(?:\s+currency="([A-Z]+)")?(?:\s+rate="([0-9.]+)")?[^>]*>/g)) {
            if (time > '2000-00-00') {
                if (match[1]) {
                    time = match[1];
                }
                else if (match[2]) {
                    if (!json[time]) {
                        json[time] = { 'EUR': 1 };
                    }
                    json[time][match[2]] = parseFloat(match[3]);
                }
            }
        }
        ECB.updated = new Date();
        return json;
    }
    static async exchangeRatesAt(date) {
        date = new Date(date);
        date.setDate(date.getDate() - 1);
        const dateString = date.toLocaleDateString('sk-SK', { timeZone: 'Europe/Bratislava' }).split(/\.\s*/).reverse().map(v => v.padStart(2, '0')).join('-');
        let lastRate = {};
        if (!ECB.rates || Date.now() - ECB.updated.getTime() > 3 * 60 * 60 * 1000) {
            ECB.rates = ECB.loadRates();
        }
        for (let [day, rate] of Object.entries(await ECB.rates)) {
            lastRate = rate;
            if (dateString >= day) {
                return rate;
            }
        }
        return lastRate;
    }
}
exports.default = ECB;
